var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.lead && _vm.lead.text)?_c('p',{staticClass:"headline-lead",domProps:{"innerHTML":_vm._f("truncate")(_vm.lead.text,_vm.maxChars)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }